import { Skeleton } from 'antd';

// Custom data source to show skeletons inside table rows
const skeletonData = Array.from({ length: 10 }, (_, index) => ({
  key: `skeleton-${index}`,
  name: <Skeleton active title={false} paragraph={{ rows: 1, width: "80%" }} />,
  description: <Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  status: <Skeleton active title={false} paragraph={{ rows: 1, width: "30%" }} />,
  action: (
    <>
      <Skeleton.Button active shape="circle" /> <Skeleton.Button active shape="circle" />
    </>
  ),
}));

// Exporting the skeletonData
export { skeletonData };
